import React, { Component } from "react";
import { Row, Col, CustomInput, Progress } from 'reactstrap';
import { AvForm, AvField, AvGroup, AvInput, AvFeedback, AvCheckbox, AvCheckboxGroup, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import PublishIcon from '@material-ui/icons/Publish';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { toAbsoluteUrl } from "../../../../_metronic";
import { translations } from '../../../../translate.js';

let Strings = localStorage.getItem('LANG') == 1 ? translations.Ar : translations.En;

class EditPosPrice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // price: this.props.cardsCalssData.price,
            price: this.props.cardsCalssData.priceDistCurr,
            priceWithTax: this.props.cardsCalssData.priceWithTax != undefined ? this.props.cardsCalssData.priceWithTax : 0,
            percentTaxFromDist: this.props.cardsCalssData.percentTaxFromDist != undefined ? this.props.cardsCalssData.percentTaxFromDist : 0,
            taxCondition: this.props.taxCondition != undefined ? this.props.taxCondition : 0,
            distId: this.props.distId ? this.props.distId : '',
            buyPriceCurr: this.props.cardsCalssData.buyPriceCurr,
            posProfit: this.props.posProfit,
            viewSellingPrice: this.props.viewSellingPrice
        }
        this.handleValidSubmit = this.handleValidSubmit.bind(this);
    }

    componentDidMount() {
        // console.log('this.props.cardsCalssData');
        // console.log(this.props.cardsCalssData.buyPriceCurr,);
    }

    handleInputChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.setState({
            [name]: value,
            submitError: ''
        }, function () {
            if (this.state.taxCondition == 1) {
                var price = name == "percentTaxFromDist" ? this.state.price : value;
                var tax = name == "percentTaxFromDist" ? value : this.state.percentTaxFromDist;
                this.calcaluteParcentTaxFromDist(tax, price);
            }
        })
    }
    calcaluteParcentTaxFromDist = (tax, price) => {
        var priceAfterTax = 0
        if (parseFloat(price) != '' && parseFloat(price) != 0 && (tax) != '' && (tax) != 0) {
            priceAfterTax = (parseFloat(price) * parseFloat(tax / 100)) + parseFloat(price);
        }
        priceAfterTax = isNaN(priceAfterTax) ? 0 : Number(priceAfterTax).toFixed(5);
        this.setState({
            priceWithTax: priceAfterTax,
            submitError: ''
        })
    }
    handleValidSubmit(event) {
        event.preventDefault();
        fetch(window.API_PERM_USER, {
            method: 'POST',
            body: JSON.stringify({
                'type': 'updatePosCardPrice',
                'lang': localStorage.getItem('LANG'),
                'userId': localStorage.getItem('USER_ID'),
                'token': localStorage.getItem('USER_TOKEN'),
                'cardClassId': this.props.cardsCalssData.id,
                'price': this.state.price,
                'percentTaxFromDist': this.state.taxCondition == 1 ? this.state.percentTaxFromDist : 0,
                'posId': this.props.posId,
                distId: this.state.distId,
                'sellingPrice': this.state.buyPriceCurr,
            }),
            headers: {
                'Accept': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(data => {
            if (data !== "Nothing found") {
                if (data['logout'] == 1) {
                    localStorage.setItem('USER_ID', '');
                    localStorage.setItem('USER_TOKEN', '');
                    window.location.href = "/logout";
                } else if (data['error'] == 0) {
                    this.props.recallGetData();
                    this.props.handleCloseSideBar()
                } else {
                    this.setState({ submitError: data['errorMsg'] })
                }
            }
        })
    }


    render() {

        return (
            <div className='view-modal-style'>
                <div className='sidebar-header-view'>
                    <Row>
                        <Col lg={10} md={10} sm={10} xs={10}>
                            <div className='p-0 main-color-1  sidebar-header-title'>
                                {Strings['Edit Classes Price']}
                                ({this.props.cardsCalssData['cardClassName']})
                            </div>
                        </Col>
                        <Col lg={2} md={2} sm={2} xs={2} className='text-right'>
                            <HighlightOffIcon onClick={this.props.handleCloseSideBar} className='modal-close-icon' />
                        </Col>
                    </Row>
                </div>

                <div className='sidebar-body-view'>
                    <AvForm onValidSubmit={this.handleValidSubmit} ref={c => (this.form = c)}>
                        <AvField name="price" type='number' label={Strings['Buy Price'] + ' *'} placeholder={Strings['Enter Buy Price']} value={this.state.price} required onChange={this.handleInputChange} errorMessage={Strings['This field is required']} />
                        {(this.state.posProfit == 1 || this.state.viewSellingPrice == 1) &&
                            <AvField
                                name="buyPriceCurr"
                                type='number'
                                label={Strings['Selling Price'] + ' *'}
                                placeholder={Strings['Enter Selling Price']}
                                value={this.state.buyPriceCurr}
                                required
                                onChange={this.handleInputChange}
                                errorMessage={Strings['This field is required']}
                            />
                        }
                        {this.state.taxCondition == 1 &&
                            <AvField name="percentTaxFromDist" type='number' label={Strings['Tax'] + ' *'} placeholder={Strings['Tax']} value={this.state.percentTaxFromDist} onChange={this.handleInputChange} />
                        }
                        {this.state.taxCondition == 1 &&
                            <AvField name="priceWithTax" type='number' label={Strings['Price With Tax']} value={this.state.priceWithTax} disabled />
                        }

                        <div className='text-right mt-4'>
                            <button type="submit" className="btn form-save-btn mr-1 ml-1"> {Strings['Save']} </button>

                            <button type="button" className="btn form-cancel-btn m-l-10" onClick={this.props.handleCloseSideBar}>{Strings['Cancel']}</button>
                        </div>

                        {this.state.submitError &&
                            <div className='error-text-black'><i className='flaticon2-exclamation error-icon mr-1' /> {this.state.submitError}</div>
                        }

                    </AvForm>
                </div>
            </div>
        )
    }
}
export default EditPosPrice;